import React from 'react';

import { Grid, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { FlightAndAncillaryIssueSummaryList } from '../../../features/operations/components/FlightAndAncillaryIssueSummaryList';
// import { isOperatorOrHigher } from '../../../features/auth/helpers';
// import { useSelector } from 'react-redux';
//import { RootState } from '../../../store';
// import { PageNotAllowedForUser } from '../../../features/common/components/PageNotAllowedForUser';

export const FlightIssuingControlListPage = (): JSX.Element => {
	//const { auth } = useSelector((state: RootState) => state);
	return (
		<Layout>
			{/* {isOperatorOrHigher(auth.user) ? ( */}
			<Grid container paddingY={5} justifyContent={'center'}>
				<Grid
					item
					xs={12}
					sx={{
						ml: 20,
					}}
				>
					<Typography variant="h4" style={{ fontWeight: 500 }}>
						Control de Emisión de Vuelos
					</Typography>
				</Grid>
				<Grid paddingY={5}>
					<FlightAndAncillaryIssueSummaryList />
				</Grid>
			</Grid>
			{/* ) : (
				<PageNotAllowedForUser />
			)} */}
		</Layout>
	);
};
